import { initHubSpotFormStitching } from './src/utils/trackFormSubmit'

const SIERA_GROUP_FORM_NAMES = {
  'da19a315-f025-49d3-a70f-5a512d5395c8': 'footer_newsletter',
  'b8e95183-1211-48f5-bc20-b0294b479a1b': 'popup_newsletter',
  '1decd293-dfd1-48d5-9846-26202f78a7e1': 'contact_overlay',
}

export const onClientEntry = () => {
  initHubSpotFormStitching(SIERA_GROUP_FORM_NAMES)
}
